import React, { useState, useEffect } from 'react';
import '../App.css';
import Header from '../components/Header';
import TournamentBracket from '../components/TournamentBracket';
import PrizesSection from '../components/PrizesSection';
import PlayerModal from '../components/PlayerModal';
import MatchModal from '../components/MatchModal';
import Footer from '../components/Footer';
import { API_BASE } from '../config/api';

const PublicView = () => {
  const [tournamentData, setTournamentData] = useState({
    roundOf16: [],
    groupOf8: [],
    quarterFinals: [],
    semiFinals: [],
    final: null
  });
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [selectedMatch, setSelectedMatch] = useState(null);
  const [selectedRound, setSelectedRound] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchTournamentData();
    // Fetch tournament data frequently for live updates
    const interval = setInterval(() => {
      fetchTournamentData();
    }, 1000); // Update every 1 second for real-time viewing

    return () => clearInterval(interval);
  }, []);

  const fetchTournamentData = async () => {
    try {
      const response = await fetch(`${API_BASE}/tournament`);
      const data = await response.json();
      setTournamentData(data);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching tournament data:', error);
      setIsLoading(false);
    }
  };

  const handlePlayerClick = (player) => {
    if (player && player.name && !player.isPlaceholder) {
      setSelectedPlayer(player);
      setSelectedMatch(null);
    }
  };

  const handleMatchClick = (match, round) => {
    if (match) {
      setSelectedMatch(match);
      setSelectedRound(round);
      setSelectedPlayer(null);
    }
  };

  // Update selected match when tournament data changes (for live updates in modal)
  useEffect(() => {
    if (selectedMatch && selectedRound) {
      let updatedMatch = null;
      
      if (selectedRound === 'roundOf16') {
        updatedMatch = tournamentData.roundOf16.find(m => m.id === selectedMatch.id);
      } else if (selectedRound === 'groupOf8') {
        updatedMatch = tournamentData.groupOf8.find(m => m.id === selectedMatch.id);
      } else if (selectedRound === 'quarterFinals') {
        updatedMatch = tournamentData.quarterFinals.find(m => m.id === selectedMatch.id);
      } else if (selectedRound === 'semiFinals') {
        updatedMatch = tournamentData.semiFinals.find(m => m.id === selectedMatch.id);
      } else if (selectedRound === 'final') {
        updatedMatch = tournamentData.final;
      }
      
      if (updatedMatch) {
        setSelectedMatch(updatedMatch);
      }
    }
  }, [tournamentData, selectedRound]);

  const closePlayerModal = () => {
    setSelectedPlayer(null);
  };

  const closeMatchModal = () => {
    setSelectedMatch(null);
    setSelectedRound(null);
  };

  if (isLoading) {
    return (
      <div className="App">
        <div className="loading-screen">
          <div className="loading-spinner"></div>
          <p>Loading tournament data...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <main className="main-content">
        <TournamentBracket 
          tournamentData={tournamentData}
          onPlayerClick={handlePlayerClick}
          onMatchClick={handleMatchClick}
        />
        <PrizesSection />
      </main>
      {selectedPlayer && (
        <PlayerModal player={selectedPlayer} onClose={closePlayerModal} />
      )}
      {selectedMatch && (
        <MatchModal 
          match={selectedMatch} 
          round={selectedRound}
          onClose={closeMatchModal}
          onPlayerClick={handlePlayerClick}
          isAdmin={false}
        />
      )}
      <Footer />
    </div>
  );
};

export default PublicView;
